/* eslint-disable jsx-a11y/media-has-caption */
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../common/TableHead";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { cancelIconRed } from "../../common/cancelIconRed";
import { checkedCircleIcon } from "../../common/checkedCircleIcon";
import {
  formatClipReceivedLocal,
  formatDateInUTC,
} from "./ClipsUtilities/formatTimeStamp";
import { roundToHundredth } from "../Sites/SiteAboutPage/SiteAboutPageUtils/roundToHundredth";

export const ShowMoreDialogFrontel = ({
  showMoreDialogOpenFrontel,
  setShowMoreDialogOpenFrontel,
  selectedRowFrontel,
  videoURLFrontel,
}: {
  showMoreDialogOpenFrontel: boolean;
  setShowMoreDialogOpenFrontel: (value: boolean) => void;
  selectedRowFrontel: any;
  videoURLFrontel: string;
}) => {
  const handleClickOpen = () => {
    setShowMoreDialogOpenFrontel(true);
  };

  const handleClose = () => {
    setShowMoreDialogOpenFrontel(false);
  };

  return (
    <div>
      <OrangeTextButton
        onClick={handleClickOpen}
        text="Full Clip Info"
        disabled={false}
      />
      <Dialog
        fullScreen
        open={showMoreDialogOpenFrontel}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {selectedRowFrontel.customer_name}
              {selectedRowFrontel.customer_name &&
              selectedRowFrontel.camera_name
                ? " | "
                : " "}
              {selectedRowFrontel.camera_name}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className="flex pt-[20px] pl-[20px]">
          <div>
            <React.Fragment>
              <video width="550" controls autoPlay loop>
                <source src={videoURLFrontel} type="video/mp4" />
              </video>
            </React.Fragment>
          </div>
          <div className="flex">
            <div id="column1" className="pl-[20px]">
              <p className="text-black font-mulish text-[16px] font-bold">
                Site
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.customer_name
                  ? selectedRowFrontel.customer_name
                  : "--"}
              </p>
              <p className="pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold">
                Event ID
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.event_id
                  ? selectedRowFrontel.event_id
                  : "--"}
              </p>
              <p className="pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold">
                Camera Name
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.camera_name
                  ? selectedRowFrontel.camera_name
                  : "--"}
              </p>
              <p className="pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold">
                Camera ID
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.camera_id
                  ? selectedRowFrontel.camera_id
                  : "--"}
              </p>
            </div>
            <div id="column2" className="pl-[100px]">
              <p className="text-black font-mulish text-[16px] font-bold">
                Local Time
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {formatClipReceivedLocal(
                  selectedRowFrontel.clip_header_received,
                  selectedRowFrontel.clip_received_local,
                  selectedRowFrontel.site_timezone
                ) || "--"}
              </p>
              <p className="pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold">
                UTC Time
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.clip_header_received
                  ? formatDateInUTC(selectedRowFrontel.clip_header_received)
                  : ""}
              </p>
              <p className="pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold">
                Internal Log ID
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.internal_id
                  ? selectedRowFrontel.internal_id
                  : "--"}
              </p>
              <p className="pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold">
                File ID
              </p>
              <p className="w-[250px] text-black font-mulish text-[16px]">
                {selectedRowFrontel.file_id ? selectedRowFrontel.file_id : "--"}
              </p>
            </div>
          </div>
        </div>
        <br></br>
        <TableContainer component={Paper}>
          <Table
            sx={{ fontFamily: "Mulish", width: "100%" }}
            aria-label="simple table"
          >
            <TableHeadComponent
              titlesArray={[
                "Probability",
                "Analyzed FPS",
                "Clip FPS",
                "Slice",
                "Stationary",
              ]}
            />
            <TableBody>
              <TableRow>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {selectedRowFrontel.probability != null
                    ? `${roundToHundredth(selectedRowFrontel.probability)}%`
                    : "--"}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {selectedRowFrontel.fps ?? "--"}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {selectedRowFrontel.stream_fps ?? "--"}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {selectedRowFrontel.slice ? checkedCircleIcon : cancelIconRed}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {selectedRowFrontel.stationary_filter
                    ? checkedCircleIcon
                    : cancelIconRed}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div className="relative min-w-[1450px] "></div>
      </Dialog>
    </div>
  );
};
